import React, { useEffect, useState } from 'react';
import { Col, Row, Form, FloatingLabel } from 'react-bootstrap';
import { fetchHVACampaignNames } from 'services/hvaservicecampaign.service';
import CampaignPerformanceFilter from './debtcollection/CampaignPerformanceFilter';
import HVASpinner from 'components/base/HVASpinner';

interface campaign {
  id: number;
  name: string;
  bxpcampaignid: number;
}

const CampaignPerformance = () => {
  const [campaigns, setCampaigns] = useState<campaign[]>([]);
  // eslint-disable-next-line
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Cargar los campaigns
  useEffect(() => {
    const loadcampaigns = async () => {
      setIsLoading(true); // Inicia el loader
      try {
        const campaignNames = await fetchHVACampaignNames();
        if (Array.isArray(campaignNames)) {
          setCampaigns(campaignNames);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        if (error instanceof Error) {
          setError('Error loading campaigns: ' + error.message);
        } else {
          setError('Unknown error occurred while loading campaigns');
        }
      } finally {
        setIsLoading(false); // Detiene el loader
      }
    };

    loadcampaigns();
  }, []);

  // Controlador para manejar la selección de campaign
  const handlecampaignChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCampaign(e.target.value);
  };

  return (
    <>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 pb-0 mb-0">
        <Row className="gy-3 mb-1 justify-content-between">
          <Col>
            <h2 className="mb-2 text-body-emphasis">
              Campaign Performance Report
            </h2>
            <h5 className="text-body-tertiary fw-semibold">
              Start by selecting a campaign
            </h5>
          </Col>
          <Col>
            <div className="d-flex w-100 align-items-center">
              <FloatingLabel
                controlId="campaigns"
                label="campaign selection"
                className="w-100"
              >
                {isLoading ? (
                  <HVASpinner />
                ) : (
                  <Form.Select
                    id="campaign"
                    value={selectedCampaign ?? ''}
                    onChange={handlecampaignChange}
                  >
                    <option value="">Select a campaign</option>
                    {campaigns.map(campaign => (
                      <option
                        key={campaign.id}
                        value={campaign.bxpcampaignid.toString()}
                      >
                        {campaign.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </FloatingLabel>
            </div>
          </Col>
        </Row>

        {/* Mostrar un mensaje de error si hay problemas al cargar los campaigns */}
        {error && <div className="text-danger mt-3">{error}</div>}
      </div>
      <div id="Content" className="mx-n4 px-4 mx-lg-n6 px-lg-6">
        {/* Llamamos a un componente o mostramos más información sobre el campaign seleccionado */}
        {selectedCampaign ? (
          <CampaignPerformanceFilter bxpcampaignid={Number(selectedCampaign)} />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default CampaignPerformance;
